import {configVariableValues} from '@shared/constants/config-variable-values.constants';
import {NgxUiTourStep, ngxUiTourValue} from '@shared/models/ngx-ui-tour.model';

export const ngxUiTourAppTours = {
  HOME_TOUR: 'homeTour',
  MENU_TOUR: 'menuTour',
  PROFILE_TOUR: 'profileTour',
  DIARY_TOUR: 'diaryTour'
};

export const ngxUiTourStepDefaults = {
  placement: 'right',
  endBtnTitle: 'SI_FINISH',
  nextBtnTitle: 'SI_NEXT',
  prevBtnTitle: 'SI_PREVIOUS',
  enableBackdrop: true,
  showPrev: true,
  showNext: true,
  showEnd: true,
  showClose: true,
  showProgress: true
} as NgxUiTourStep;

export const ngxUiTourStepsHome = [
  {
    anchorId: 'home.welcome',
    title: 'SI_LOGIN_TITLE',
    content: 'SI_TOUR_HOME_WELCOME',
    containerClass: 'ngx-ui-tour_centered-tour-element',
    showStart: true,
    showCancel: true,
    showClose: false
  },
  {
    anchorId: 'home.language',
    title: 'SI_TOUR_LANGUAGE_TITLE',
    content: 'SI_TOUR_LANGUAGE_TEXT'
  },
  {
    anchorId: 'home.notification',
    title: 'SI_NOTIFICATIONS',
    content: 'SI_TOUR_NOTIFICATION_TEXT'
  },
  {
    anchorId: 'home.menu',
    title: 'SI_TOUR_MENU_TITLE',
    content: 'SI_TOUR_MENU_TEXT'
  }
] as NgxUiTourStep[];

export const ngxUiTourStepsMenu = [
  {
    anchorId: 'menu.home',
    title: 'SI_HOME',
    content: 'SI_TOUR_RETURN_HOME_TEXT',
    placement: 'bottom'
  },
  {
    anchorId: 'menu.appointment',
    title: 'SI_APPOINTMENTS',
    content: 'SI_TOUR_APPOINTMENT_TEXT',
    placement: 'bottom',
    permissions: ['appointment_management:search']
  },
  {
    anchorId: 'menu.history',
    title: 'SI_CLINICAL_HISTORY',
    content: 'SI_TOUR_HISTORY_TEXT',
    placement: 'bottom',
    permissions: ['clinical_history:access']
  },
  {
    anchorId: 'menu.medical-test',
    title: 'SI_MEDICAL_REQUESTS',
    content: 'SI_TOUR_MEDICAL_TEXT_TEXT',
    placement: 'bottom',
    permissions: ['patient_requests:management']
  },
  {
    anchorId: 'menu.intervention',
    title: 'SI_INTERVENTIONS',
    content: 'SI_TOUR_INTERVENTION_TEXT',
    placement: 'bottom',
    permissions: ['intervention:search']
  },
  {
    anchorId: 'menu.vital-sign',
    title: 'SI_VITAL_SIGNS_SHORT',
    content: 'SI_TOUR_VITAL_SIGN_TEXT',
    placement: 'bottom',
    permissions: ['vital_sign:management'],
    configurationKeys: [configVariableValues.VITAL_SIGNS]
  },
  {
    anchorId: 'menu.diary',
    title: 'SI_DIARY',
    content: 'SI_TOUR_DIARY_TEXT',
    placement: 'bottom',
    permissions: ['calendar:diary_management']
  },
  {
    anchorId: 'menu.questionnaire',
    title: 'SI_QUESTIONNAIRES',
    content: 'SI_TOUR_QUESTIONNAIRE_TEXT',
    placement: 'bottom',
    permissions: ['questionnaire:management'],
    configurationKeys: [configVariableValues.CAREPATH]
  },
  {
    anchorId: 'menu.medical-team',
    title: 'SI_MEDICAL_TEAM',
    content: 'SI_TOUR_MEDICAL_TEAM_TEXT',
    placement: 'bottom',
    permissions: ['his_get:medical_team']
  },
  {
    anchorId: 'menu.schedule-ambulance',
    title: 'SI_SCHEDULE_AMBULANCE',
    content: 'SI_TOUR_SHEDULE_AMBULANCE_TEXT',
    placement: 'bottom',
    permissions: ['procedure:ambulance']
  },
  {
    anchorId: 'menu.be-phoned',
    title: 'SI_REQUEST_BE_PHONED',
    content: 'SI_TOUR_BE_PHONED_TEXT',
    placement: 'bottom',
    permissions: ['procedure:callme']
  },
  {
    anchorId: 'menu.configuration',
    title: 'SI_PERMISSION_MANAGEMENT',
    content: 'SI_TOUR_CONFIGURATION_TEXT',
    placement: 'bottom',
    permissions: ['system_configuration:roles_permissions']
  },
  {
    anchorId: 'menu.profile',
    title: 'SI_PROFILE',
    content: 'SI_TOUR_PROFILE_TEXT',
    placement: 'bottom'
  },
  {
    anchorId: 'menu.access-as',
    title: 'SI_ACCESS_AS',
    content: 'SI_TOUR_ACCESS_AS_TEXT',
    placement: 'bottom',
    permissions: ['my_circle:get_authorized_by']
  }
] as NgxUiTourStep[];

export const ngxUiTourStepsProfile = [
  {
    anchorId: 'profile.welcome',
    title: 'SI_PROFILE',
    content: 'SI_TOUR_PROFILE_TEXT',
    route: '/profile/dashboard',
    containerClass: 'ngx-ui-tour_centered-tour-element',
    placement: 'bottom'
  },
  {
    anchorId: 'profile.edit',
    title: 'SI_EDIT_PROFILE',
    content: 'SI_TOUR_EDIT_PROFILE_TEXT',
    route: '/profile/dashboard',
    placement: 'bottom',
    permissions:
      [
        'user_profile:update_personal_data',
        'user_profile:update_contact_data',
        'user_profile:update_address',
        'user_profile:update_insurance_preferences'
      ],
    permissionsOperation: 'or'
  },
  {
    anchorId: 'profile.my-circle',
    title: 'SI_MY_CIRCLE',
    content: 'SI_TOUR_MY_CIRCLE_TEXT',
    route: '/profile/dashboard',
    placement: 'bottom',
    permissions: ['my_circle:get_authorized_by']
  },
  {
    anchorId: 'profile.settings',
    title: 'SI_SETTINGS',
    content: 'SI_TOUR_SETTINGS_TEXT',
    route: '/profile/dashboard',
    placement: 'bottom'
  }
] as NgxUiTourStep[];

export const ngxUiTourStepsDiary = [
  {
    anchorId: 'diary.welcome',
    title: 'SI_DIARY',
    content: 'SI_TOUR_DIARY_TEXT',
    route: '/diary',
    containerClass: 'ngx-ui-tour_centered-tour-element',
    placement: 'bottom'
  },
  {
    anchorId: 'diary.new-event',
    title: 'SI_ADD_EVENT',
    content: 'SI_TOUR_NEW_EVENT_TEXT',
    route: '/diary',
    placement: 'bottom'
  },
  {
    anchorId: 'diary.visualization',
    title: 'SI_TOUR_VISUALIZATION_MODE_TITLE',
    content: 'SI_TOUR_VISUALIZATION_MODE_TEXT',
    route: '/diary',
    placement: 'bottom'
  },
  {
    anchorId: 'diary.welcome',
    title: 'SI_EVENTS',
    content: 'SI_TOUR_EVENT_DETAIL_TEXT',
    route: '/diary',
    containerClass: 'ngx-ui-tour_centered-tour-element',
    placement: 'bottom'
  }
] as NgxUiTourStep[];

export const ngxUiTourAppTourValues = [
  {
    tour: ngxUiTourAppTours.HOME_TOUR,
    name: 'SI_HOME',
    route: '/',
    icon: 'icon-home'
  },
  {
    tour: ngxUiTourAppTours.MENU_TOUR,
    name: 'SI_MENU',
    route: '/',
    icon: 'icosun-menu'
  },
  {
    tour: ngxUiTourAppTours.PROFILE_TOUR,
    name: 'SI_PROFILE',
    route: '/profile/dashboard',
    icon: 'icosun-user_circle'
  },
  {
    tour: ngxUiTourAppTours.DIARY_TOUR,
    name: 'SI_DIARY',
    route: '/diary',
    icon: 'icosun-notebook',
    permissions: ['calendar:diary_management']
  }
] as ngxUiTourValue[];
